export default __webpack_public_path__ + "static/spot-sleep-2c7fe1150135a96c050568ef27aae44c.jpg";